// extracted by mini-css-extract-plugin
module.exports = {"box":"IalurilBox_box__1JTpX","boxImg":"IalurilBox_boxImg__24tsN","boxTitle":"IalurilBox_boxTitle___esgQ","title":"IalurilBox_title__2EnoL","icon":"IalurilBox_icon__2wM8P"};